export enum InsuranceInformationConstants {
  SET_INSURANCE_CARRIER = 'insuranceInformation/SET_INSURANCE_CARRIER',
  SET_GROUP_NAME = 'insuranceInformation/SET_GROUP_NAME',
  SET_GROUP_NUMBER = 'insuranceInformation/SET_GROUP_NUMBER',
  SET_POLICY = 'insuranceInformation/SET_POLICY',
  SET_PRIORITY = 'insuranceInformation/SET_PRIORITY',
  SET_INSURED = 'insuranceInformation/SET_INSURED',
  SET_ACTIVE = 'insuranceInformation/SET_ACTIVE',
  SET_INSURANCE_INFORMATION_LIST = 'insuranceInformation/SET_INSURANCE_INFORMATION_LIST',
  SAVE_INSURANCE_INFORMATION = 'insuranceInformation/SAVE_INSURANCE_INFORMATION',
  ADD_INSURANCE_INFORMATION = 'insuranceInformation/ADD_INSURANCE_INFORMATION',
  REMOVE_INSURANCE_INFORMATION = 'insuranceInformation/REMOVE_INSURANCE_INFORMATION',
  CLEAR_INSURANCE_INFORMATION_DATA = 'insuranceInformation/CLEAR_INSURANCE_INFORMATION_DATA',
  RESET_STATE = 'insuranceInformation/RESET_STATE',
  SET_SELECTED_INSURANCE = 'insuranceInformation/SET_SELECTED_INSURANCE',
  SET_INSURANCE_INFORMATION_STATE = 'insuranceInformation/SET_INSURANCE_INFORMATION_STATE',
  SET_INSURANCE_INFORMATION_DATA = 'insuranceInformation/SET_INSURANCE_INFORMATION_DATA',
}
